module.exports = __webpack_public_path__ + "img/quxian.1355c644.png";